import restrictionsFacade from '../../restrictions/restrictions';

module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  crop: function (element, params = {}) {
    const layoutBox = this._convertToLayoutBox(element, params);
    if (!restrictionsFacade.canChange(element, 'position')) {
      return;
    }

    this.canvas.call('advice.show', 'convert-to-layout-box');
    this.canvas.addToSelection([layoutBox], true);

    if (!params.quiet) this.cropBoxSelection(layoutBox, params);
  },

  cropBoxSelection: function (element) {
    const id = element.getAttribute('id');

    this.trigger('crop.start', { id });

    this.canvas.runExtensions('showLayoutClipper', {
      layout: element,
      callback: () => {
        this.trigger('crop.end', { id });
      }
    });
  },

  _convertToLayoutBox: function (element, params) {
    if (element.hasAttribute('clip-path')) return element;

    element.classList.add('layoutBox');

    const originalBox = this.canvas.getBBox(element);
    const clipPathBB = params.clip_path || originalBox;

    return this.canvas.runExtensions('addVideoLayoutBox', {
      element,
      clipPathBB
    });
  }
}, Backbone.Events);
